export enum ClientRegistrationState {
  None = 0,
  Invited = 1,
  Registered = 2
}
